import { render } from "./DatiFatturazione.vue?vue&type=template&id=9f65d760"
import script from "./DatiFatturazione.vue?vue&type=script&lang=js"
export * from "./DatiFatturazione.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__